export default __webpack_public_path__ + "static/media/pay-op.299b15dd.svg";